var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastColorWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M10.937.882c.006-.446-.126-.83-.304-.882h-.79c-.176.058-.303.39-.303.882 0 .493-.362 15.52-.54 23.213 0 .51.213.905.504.905h1.492c.29 0 .517-.396.503-.905-.196-7.738-.384-15.475-.562-23.213z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M2 4.5L18 4.5",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(0 9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 1L2.833 2.5 3.167 2.5 3.167 3.5 1.833 3.5 1.833 2.5 2.167 2.5 2.167 1z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(0 9) translate(0 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 0C4.702 0 5 .298 5 .667c0 .368-.298.666-.667.666-.246 0-.462-.134-.577-.333H1.244c-.115.2-.33.333-.577.333C.298 1.333 0 1.035 0 .667 0 .298.298 0 .667 0c.246 0 .462.134.577.333h2.512C3.87.134 4.086 0 4.333 0z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(0 9) translate(0 .2)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 1L2.833 2.5 3.167 2.5 3.167 3.5 1.833 3.5 1.833 2.5 2.167 2.5 2.167 1z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(0 9) translate(15 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 0C4.702 0 5 .298 5 .667c0 .368-.298.666-.667.666-.246 0-.462-.134-.577-.333H1.244c-.115.2-.33.333-.577.333C.298 1.333 0 1.035 0 .667 0 .298.298 0 .667 0c.246 0 .462.134.577.333h2.512C3.87.134 4.086 0 4.333 0z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(0 9) translate(15 .2)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M2 4.5L16 4.5",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 1L2.833 2.5 3.167 2.5 3.167 3.5 1.833 3.5 1.833 2.5 2.167 2.5 2.167 1z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(1) translate(0 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 0C4.702 0 5 .298 5 .667c0 .368-.298.666-.667.666-.246 0-.462-.134-.577-.333H1.244c-.115.2-.33.333-.577.333C.298 1.333 0 1.035 0 .667 0 .298.298 0 .667 0c.246 0 .462.134.577.333h2.512C3.87.134 4.086 0 4.333 0z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(1) translate(0 .2)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 1L2.833 2.5 3.167 2.5 3.167 3.5 1.833 3.5 1.833 2.5 2.167 2.5 2.167 1z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(1) translate(13 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 0C4.702 0 5 .298 5 .667c0 .368-.298.666-.667.666-.246 0-.462-.134-.577-.333H1.244c-.115.2-.33.333-.577.333C.298 1.333 0 1.035 0 .667 0 .298.298 0 .667 0c.246 0 .462.134.577.333h2.512C3.87.134 4.086 0 4.333 0z",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5) translate(0 2) translate(1) translate(13 .2)"
  }))))), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M11.373 17.226L9 21.058M11.178 9.34L9.352 13.2M11.373 24.702L9 21.058M11.373 17.226L9.352 13.2M11.178 9.34L9.614 4.728 10.937.882",
    transform: "translate(-294 -10) translate(272) translate(22 11) translate(3 .5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastColorWhite);
export default __webpack_public_path__ + "static/media/mast-color-white.3594f09e.svg";
export { ForwardRef as ReactComponent };